'use strict';

module.exports = function () {
    $('.currency-selector').on('click', function (e) { // To handle currency selection based on user click
        e.preventDefault();
        var urlParams = new URLSearchParams(window.location.search);
        var isCustomizable = urlParams.get('isCustomizable');
        var currentCurrency = $('.currency-options').data('currency');
        var isLoyaltyPage = urlParams.get('page') === 'loyaltypoints';

        if (isCustomizable === 'true' && currentCurrency === 'INR') {
            $('#currencychangecustomizationrestrictionmodal').modal('show');
            return false;
        }

        if (isLoyaltyPage) {
            var toastMessageHelper = require('../utils/toastMessageHelper');
            var message = $('.loyalty-enrollment-restriction-msg').val();
            toastMessageHelper.showNotification(message);
            return false;
        }

        var action = $('.page').data('action');
        var localeCode = $(this).data('locale');
        var localeCurrencyCode = $(this).data('currencycode');
        var queryString = $('.page').data('querystring');
        var url = $(this).data('url');
        var currentURL = new URL(window.location);
        var params = new URLSearchParams(queryString);
        params.delete('pmax');
        params.delete('pmin');
        queryString = params.toString();

        // Remove 'selected' class from all options and add it to the clicked one
        // $('.main-texts.currency-selector').removeClass('selected');
        // $(this).addClass('selected');
        $('#currency-list').collapse('hide');
        $('.lang-n-currency-set').addClass('collapsed');

        $.spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                code: localeCode,
                queryString: queryString,
                CurrencyCode: localeCurrencyCode,
                locale: localeCode,
                action: action
            },
            success: function (data) {
                $.spinner().stop();
                if (data.error) {
                    if (data.updateCurrency) {
                        currentURL.searchParams.set('currencyCode', data.updatedCurrencyCode);
                        window.history.replaceState(null, '', currentURL.toString());
                    }
                    $('#currency-or-locale-change-restricted').modal('show');
                } else {
                    $.spinner().start();
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    } else {
                        window.location.reload();
                    }
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });

        return true;
    });
};

var selectedCurrency = $('.selected-prefrence.currency-options').attr('data-currency');
// Updating the element's text to show the selected currency
$('.selected-prefrence.currency-options').text(selectedCurrency);
